
export default {
  name: 'InstagramLogo',
  computed: {
    gradientId() {
      return `instagram-logo-gradient-${this._uid}`
    },
  },
}
